import { render } from "./menuitems.vue?vue&type=template&id=512e11af"
import script from "./menuitems.vue?vue&type=script&lang=js"
export * from "./menuitems.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__